<template>
  <div>
    <el-button type="primary" style="margin-bottom: 20px;" @click="add">添加分类</el-button>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="120px"></el-table-column>
      <el-table-column label="分类名称" prop="title"></el-table-column>
      <el-table-column label="是否显示" prop="is_show">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_show==1">是</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_show==0">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort"></el-table-column>
      <el-table-column label="创建时间" prop="addtime"></el-table-column>
<!--      <el-table-column label="支付状态" prop="">-->
<!--        <template v-slot="scope">-->
<!--          <el-tag type="success" size="small" v-if="scope.row.is_pay==1">已支付</el-tag>-->
<!--          <el-tag type="info" size="small" v-if="scope.row.is_pay==0">未支付</el-tag>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="操作" width="220px">
        <template v-slot="scope">
          <el-button type="primary" @click="edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>
          <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <layer-page :total="total" :page-size="20"></layer-page>
    <layer-pop title="添加/编辑分类" @close="vue_pop_show_hide" v-if="is_pop">
      <div class="mt-20">
        <el-form label-width="120px" ref="post" :model="post" :rules="rules">
          <el-form-item label="分类名称" prop="title" >
            <el-input placeholder="分类名称" v-model.trim="post.title" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="" >
            <el-switch v-model="post.is_show"  active-value="1" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>
          <el-form-item label="排序" prop="" >
            <el-input placeholder="排序" v-model="post.sort" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">确定提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </layer-pop>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page.vue";
import LayerPop from "@/components/layer-pop.vue";
export default {
name: "page_sort",
  components: {LayerPop, LayerPage},
  data(){
    return{
      rules : {
        title : [{required : true, message : '请填写', trigger : 'blur'}],
      },
      list:[],
      is_load:false,
      page:1,
      total:0,
      is_pop:false,
      post:{}
    }
  },
  mounted : async function(){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods:{
    get_list: async function (){
      if(!this.is_load){
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.page('sort_list', {page: this.page,uid:this.user.uid});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    add:function (){
      this.post = {};
      this.is_pop = true;
    },
    edit:async function (id){
      this.$_showLoading();
      let res = await this.$_api.page('sort_detail',{id:id});
      this.$_hideLoading();
      if(res.errcode == 0){
        this.post = res.data;
        this.is_pop = true;
      }
    },
    del:async function (id){
      this.$_showLoading();
      let res = await this.$_api.page('sort_del',{id:id});
      this.$_hideLoading();
      if(res.errcode == 0){
        this.$_showToast(res.errmsg,res.style);
        await this.get_list();
      }
    },
    submit:async function (){
      let post = this.post;
      post['uid'] =  this.user.uid;
      this.$_showLoading();
      let res = await this.$_api.page('sort_add', post);
      this.$_hideLoading();
      if(res.errcode == 0){
        this.$_showToast(res.errmsg,res.style);
        await this.get_list();
        this.is_pop = false;
      }
    }
  }
}
</script>

<style scoped>

</style>